import { render, staticRenderFns } from "./playvideo.vue?vue&type=template&id=c39171da&scoped=true"
import script from "./playvideo.vue?vue&type=script&lang=js"
export * from "./playvideo.vue?vue&type=script&lang=js"
import style0 from "./playvideo.vue?vue&type=style&index=0&id=c39171da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39171da",
  null
  
)

export default component.exports